window.addEventListener("DOMContentLoaded", () => {
    if(typeof particleConfig === 'undefined') {
        return false;
    }

    // Check if animation was already dismissed (for CDN caching)
    const modalGuid = particleConfig.modalGuid;
    const cookieValue = document.cookie.split('; ').find(row => row.startsWith('merlin_particle-animation='));
    
    if (cookieValue) {
        try {
            const cookieData = JSON.parse(decodeURIComponent(cookieValue.split('=')[1]));
            const dismissedAnimation = Array.isArray(cookieData) 
                ? cookieData.find(x => x.CookieId === modalGuid)
                : null;
            
            if (dismissedAnimation && new Date(dismissedAnimation.ShowAfter) > new Date()) {
                // Animation was dismissed and should not show yet
                return false;
            }
        } catch (e) {
            // If cookie parsing fails, continue to show animation
            console.warn('Failed to parse particle animation cookie:', e);
        }
    }

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    const config = particleConfig;
    const type = config.type || '';
    const duration = config.duration == 0 ? 30000 : config.duration * 1000;
    const images = Array.isArray(config.images) && config.images.length > 0 ? config.images : null;

    const defaultColorsAutumn = ['#ff0000', '#ff4d00', '#ffa21f', '#fedd39', '#c2000'];
    const defaultColorsConfetti = ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'];
    const defaultColorsEaster = ["#ffd500", "#fbff00", "#fcfe6c", "#fed716", "#f0ff24"];
    const defaultColorsFireworks = ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'];
    const defaultColorsSnow = ["#ffffff", "#eeeeee", "#dddddd", "#cccccc", "#bbbbbb"];
    const defaultColorsPirate = ["#c73915", "#e19c18", "#e7b439", "#333333", "#8a3324"];
    let colors;
    
    const siteConfig = {};
    Object.assign(siteConfig, window.merlinConfig);
    const defaults = { zIndex: 1000, disableForReducedMotion: true };

    let payload = {};
    payload.Guid = modalGuid;

    //Set cookie
    $.ajax({
        url: `${siteConfig.urlPrefix}/umbraco/api/particleanimation/set`,
        method: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(payload)
    }).done(function (data) {
        //do nothing
    }).fail(function (data) {
    }).always(function () {
        //do nothing
    });

    switch(type.toLowerCase()) {
        case 'fireworks':
            colors = config.colors.length < 1 ? defaultColorsFireworks : config.colors;
            fireworksEffect();
            break;
        case 'confetti':
            colors = config.colors.length < 1 ? defaultColorsConfetti : config.colors;
            confettiEffect();
            break;  
        case 'snow':
            colors = config.colors.length < 1 ? defaultColorsSnow : config.colors;
            snowEffect();
            break;  
        case 'autumn':
            colors = config.colors.length < 1 ? defaultColorsAutumn : config.colors;
            autumnEffect();
            break;
        case 'halloween':
            halloweenEffect();
            break;
        case 'easter':
            colors = config.colors.length < 1 ? defaultColorsEaster : config.colors;
            easterEffect();
            break;
        case 'pirate':
            colors = config.colors.length < 1 ? defaultColorsPirate : config.colors;
            pirateEffect();
            break;            
    }

    /**
     * FIREWORKS
     */
    function fireworksEffect() {
        const animationEnd = Date.now() + duration;
        
        function initFirework() {
            const timeLeft = animationEnd - Date.now();
        
            const particleCount = 150 * (timeLeft / duration);
            confetti({ 
                ...defaults,
                startVelocity: 30, 
                spread: 360, 
                ticks: 100, 
                shapes: ['circle'], 
                colors: colors,
                particleCount, 
                origin: { x: randomInRange(0.1, 0.9), y: randomInRange(0.1, 0.9) },
                scalar: randomInRange(0.2, 0.5),
            });

            if (timeLeft > 0) {
                setTimeout(initFirework, randomInRange(500, 750));
            }
        }
        
        initFirework();
    }    

    /**
     * CONFETTI
     */
    function confettiEffect() {
        const interval = setInterval(function() {
            initConfetti();
        }, 150);

        setTimeout(() => {
            clearTimeout(interval);
        }, duration);

        function initConfetti() {
            confetti({
                ...defaults,
                particleCount: 6,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: Math.random(),
                    y: 0
                },
                colors: colors,
                shapes: ['circle', 'square'],
                gravity: randomInRange(0.5, 0.7),
                scalar: randomInRange(0.8, 1.2),
                drift: randomInRange(-0.4, 0.8),
                zIndex: 1000,
            });
        };
    }

    /**
     * SNOW
     */
    function snowEffect() {

        const interval = setInterval(function() {
            init();
        }, 100);

        setTimeout(() => {
            clearTimeout(interval);
        }, duration);

        function init() {
            confetti({
                ...defaults,
                particleCount: 6,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                x: Math.random(),
                y: 0
                },
                colors: colors,
                shapes: ['circle'],
                gravity: randomInRange(0.5, 0.7),
                scalar: randomInRange(0.1, 0.4),
                drift: randomInRange(-0.4, 0.4),
            });
        }
    }

    /**
     * AUTUMN
     */
    function autumnEffect() {
        const scalar = 6;
        const leaves01 = confetti.shapeFromText({ text: '🍁', scalar });
        const leaves02 = confetti.shapeFromText({ text: '🍂', scalar });

        const interval = setInterval(function() {
            init()
        }, 100);

        setTimeout(() => {
            clearTimeout(interval);
        }, duration);

        function init() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: randomInRange(-1, 1),
                    y: 0
                },
                shapes: [leaves01, leaves02],
                gravity: randomInRange(0.4, 0.8),
                scalar: randomInRange(1, 4),
                drift: randomInRange(1, 3),
            });
        }

        const interval2 = setInterval(function() {
            initConfetti();
        }, 500);

        setTimeout(() => {
            clearTimeout(interval2);
        }, duration);

        function initConfetti() {
            confetti({
                ...defaults,
                particleCount: 6,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: randomInRange(-1, 1),
                    y: 0
                },
                colors: colors,
                shapes: ['circle', 'square'],
                gravity: randomInRange(0.4, 0.8),
                scalar: randomInRange(0.3, 0.8),
                drift: randomInRange(1, 3),
                zIndex: 1000,
            });
        };        
    }

    /**
     * HALLOWEEN
     */
    function halloweenEffect() {
        const scalar = 6;
        const bat = confetti.shapeFromText({ text: '🦇', scalar });
        const ghost = confetti.shapeFromText({ text: '👻', scalar });

        const intervalBats = setInterval(function() {
            initBats();
        }, 250);

        const intervalGhosts = setInterval(function() {
            initGhosts();
        }, 1000);

        setTimeout(() => {
            clearTimeout(intervalBats);
            clearTimeout(intervalGhosts);
        }, duration);

        //Bats
        function initBats() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 0,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: randomInRange(0, 2),
                    y: 1
                },
                shapes: [bat],
                gravity: randomInRange(-0.5, -1.2),
                scalar: randomInRange(1, 4),
                drift: randomInRange(-1, -3),
                flat: true
            });
        }

        //Ghosts
        function initGhosts() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 0,
                ticks: randomInRange(400, 600),
                origin: {
                    x: randomInRange(0, 1),
                    y: 1
                },
                shapes: [ghost],
                gravity: randomInRange(-0.3, -0.8),
                scalar: randomInRange(1.5, 3),
                drift: randomInRange(-0.5, 0.5),
                flat: true
            });
        }
    }

    /**
    * SNOW
    */
    function easterEffect() {
        const scalar = 6;
        const chick = confetti.shapeFromText({ text: '🐣', scalar });
        const rabbit = confetti.shapeFromText({ text: '🐰', scalar });
        

        const interval = setInterval(function() {
            initEaster();
        }, 500);

        setTimeout(() => {
            clearTimeout(interval);
        }, duration);

        function initEaster() {
            confetti({
                ...defaults,
                particleCount: 2,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                x: Math.random(),
                y: 0
                },
                colors: colors,
                shapes: [chick, rabbit],
                gravity: randomInRange(0.5, 0.7),
                scalar: randomInRange(1.5, 2),
                drift: randomInRange(-0.4, 0.4),
                flat: true
            });
        }

        const interval2 = setInterval(function() {
            initEasterConfetti();
        }, 300);

        setTimeout(() => {
            clearTimeout(interval2);
        }, duration);

        function initEasterConfetti() {
            confetti({
                ...defaults,
                particleCount: 6,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: Math.random(),
                    y: 0
                },
                colors: colors,
                shapes: ['circle', 'square'],
                gravity: randomInRange(0.5, 0.7),
                scalar: randomInRange(0.25, 0.5),
                drift: randomInRange(-0.4, 0.8),
                zIndex: 1000,
            });
        };

    }

    /**
     * PIRATE
     */
    function pirateEffect() {
        const scalar = 6;
        const flag = confetti.shapeFromText({ text: '🏴‍☠️', scalar });
        const skull = confetti.shapeFromText({ text: '☠️', scalar });
        const palmtree = confetti.shapeFromText({ text: '🌴', scalar });
        const parrot = confetti.shapeFromText({ text: '🦜', scalar });
        const money = confetti.shapeFromText({ text: '💰', scalar });

        const intervalParrots = setInterval(function() {
            initParrots();
        }, 750);

        const intervalSkulls = setInterval(function() {
            initSkulls();
        }, 250);

        const intervalFlags = setInterval(function() {
            initFlags()
        }, 250);

        setTimeout(() => {
            clearTimeout(intervalParrots);
            clearTimeout(intervalSkulls);
            clearTimeout(intervalFlags);
        }, duration);

        //Skulls
        function initSkulls() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 25,
                ticks: randomInRange(600, 800),
                origin: {
                    x: randomInRange(0, 1),
                    y: 0
                },
                shapes: [skull, palmtree, money],
                gravity: randomInRange(0.35, 0.75),
                scalar: randomInRange(1.5, 3),
                drift: randomInRange(-0.5, 0.5),
                flat: true
            });
        }

        //Flags
        function initFlags() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 25,
                ticks: randomInRange(800, 1200),
                origin: {
                    x: randomInRange(-1, 1),
                    y: 0
                },
                shapes: [flag],
                gravity: randomInRange(0.4, 0.8),
                scalar: randomInRange(1, 4),
                drift: randomInRange(1, 3),
            });
        }        

        //Parrots
        function initParrots() {
            confetti({
                ...defaults,
                particleCount: 1,
                startVelocity: 25,
                ticks: randomInRange(600, 800),
                origin: {
                    x: randomInRange(0, 1),
                    y: 1
                },
                shapes: [parrot],
                gravity: randomInRange(0.35, 0.75),
                scalar: randomInRange(1.5, 3),
                drift: randomInRange(-0.5, 0.5),
                flat: true
            });
        }
    }    

    /**
     * IMAGE CONFETTI (Canvas-based, falling images)
     * Usage: set particleConfig.type = 'imageconfetti' and provide config.images = [array of image URLs]
     */

    if(images !== null) {
        imageConfettiEffect();
    }

    function imageConfettiEffect() {
        const images = Array.isArray(config.images) && config.images.length > 0
            ? config.images
            : [];

        // Setup canvas
        let canvas = document.getElementById('image-confetti-canvas');
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.id = 'image-confetti-canvas';
            canvas.style.position = 'fixed';
            canvas.style.left = 0;
            canvas.style.top = 0;
            canvas.style.pointerEvents = 'none';
            canvas.style.zIndex = 10000;
            document.body.appendChild(canvas);
        }
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // Handle resize
        window.addEventListener('resize', () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        });

        // Load images
        const loadedImages = [];
        let loadedCount = 0;
        images.forEach(src => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                loadedImages.push(img);
                loadedCount++;
                if (loadedCount === images.length) {
                    // Add delay before starting confetti
                    setTimeout(startConfetti, config.confettiDelay || 2500); // default 2.5s delay
                }
            };
        });

        function startConfetti() {
            const ctx = canvas.getContext('2d');
            const particles = [];
            const particleCount = Math.max(10, Math.min(40, Math.floor(window.innerWidth / 40)));
            
            for (let i = 0; i < particleCount; i++) {
                const img = loadedImages[Math.floor(Math.random() * loadedImages.length)];
                particles.push({
                    img,
                    x: Math.random() * canvas.width,
                    y: -Math.random() * canvas.height,
                    size: 24 + Math.random() * 24,
                    speedY: 1.2 + Math.random() * 1.8,
                    speedX: (Math.random() - 0.5) * 1.5,
                    rotation: Math.random() * 360,
                    rotationSpeed: (Math.random() - 0.5) * 2,
                });
            }

            let startTime = null;
            let spawning = true;

            function animateConfetti(ts) {
                if (!startTime) startTime = ts;
                const elapsed = ts - startTime;
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // Stop spawning new particles after duration
                if (elapsed > duration) spawning = false;

                // Only respawn if still spawning
                particles.forEach(p => {
                    p.x += p.speedX;
                    p.y += p.speedY;
                    p.rotation += p.rotationSpeed;

                    // Calculate fade out: last 20% of duration
                    let alpha = 1;
                    const fadeStart = duration + 4000;
                    if (elapsed > fadeStart) {
                        alpha = Math.max(0, 1 - ((elapsed - fadeStart) / (duration * 0.4)));
                    }

                    // If spawning, respawn off-screen particles; otherwise, let them float away
                    if (spawning && p.y > canvas.height + p.size) {
                        p.x = Math.random() * canvas.width;
                        p.y = -p.size;
                        p.speedY = 1.5 + Math.random() * 2.5;
                        p.speedX = (Math.random() - 0.5) * 1.5;
                        p.rotation = Math.random() * 360;
                        p.rotationSpeed = (Math.random() - 0.5) * 2;
                        p.img = loadedImages[Math.floor(Math.random() * loadedImages.length)];
                    }

                    ctx.save();
                    ctx.globalAlpha = alpha;
                    ctx.translate(p.x, p.y);
                    ctx.rotate((p.rotation * Math.PI) / 180);
                    ctx.drawImage(p.img, -p.size / 2, -p.size / 2, p.size, p.size);
                    ctx.restore();
                });

                // Remove canvas only when all particles have floated off screen
                const allGone = particles.every(p => p.y > canvas.height + p.size);
                if (!allGone) {
                    requestAnimationFrame(animateConfetti);
                } else {
                    canvas.remove();
                }
            }
            requestAnimationFrame(animateConfetti);
        }
    }
});